module.exports = __webpack_public_path__ + "static/media/check_icon.2686c559.svg";